import { Box, Image, ImageOverlay, ResultIcon } from 'ui';

import { PreviewGalleryImage } from '../../types';

export const PreviewImage = ({
  image,
  isPortrait,
  height = '100%',
}: {
  image: PreviewGalleryImage;
  isPortrait?: boolean;
  height?: string | number;
}) => {
  const showError = image.status === 'warning';
  return (
    <Box
      sx={({ palette, spacing }) => ({
        border: showError ? `3px solid ${palette.error[200]}` : `1px solid ${palette.layout[100]}`,
        borderRadius: spacing(0.5),
        height,
        position: 'relative',
        width: isPortrait ? 'auto' : '100%',
      })}
    >
      {image.status !== undefined ? (
        <ImageOverlay lighten>
          <ResultIcon
            variant={image.status}
            size="small"
            sx={{
              position: 'absolute',
              right: '50%',
              top: '50%',
              transform: 'translate(50%, -50%)',
            }}
          />
        </ImageOverlay>
      ) : null}
      <Image src={image.src} rounded={false} />
    </Box>
  );
};
